import {Injectable} from '@angular/core';
import {NavigationExtras, ActivatedRoute} from '@angular/router';
// import { Storage } from '@ionic/storage';
import * as _ from 'lodash';
// import * as moment from 'moment';
import {environment} from 'src/environments/environment';
// import { StorageService } from '../storage-service/storage.service';
declare var $: any;
import { Platform } from '@ionic/angular';
import { format, intervalToDuration, differenceInDays, differenceInWeeks, differenceInQuarters, differenceInMonths, differenceInYears, subDays, addDays, addWeeks, subWeeks, lastDayOfMonth, subMonths, addMonths, subYears, addYears, startOfQuarter, endOfQuarter, parseISO, parse } from 'date-fns';
import * as moment from 'moment';
import { enIN } from 'date-fns/locale';
import { differenceInMinutes } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  // static storageService: StorageService = new StorageService(new Storage({driverOrder: ['localstorage']}));

    constructor(private platform : Platform) {}

    public static isNullOrEmpty(input : any): boolean {
        return input == null || input.trim().length === 0;
    }

    public static isNumeric(value : any): boolean {
        const regexp = /^-?\d+(\.\d{1,10})?$/;
        return regexp.test(value);
    }

    public static formatDate(value : string): string { // return moment(value).format('DD-MMM-YYYY');
        var val = new Date(value);
        // return val.toLocaleDateString("en-IN",{'dateStyle':'medium'});
        return val.toLocaleString('en-IN', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        }).split(' ').join('-');
    }

    /**
   * Formats date with time.
   * Supported formats toDateString ,toISOString and "24-DEC-2022".
   * @param value in string.
   * @returns date with time in string format
   */
    public static  formatDateWithTime(value: string): string {
      try {
        if (!value || !moment(value).isValid()) {
          return null;
        } else {
          let dt = moment(value).format('DD-MMM-YYYY hh:mm:ss');
          return dt;
        }
      } catch (error) {
        return null;
      }
    }

    public static checkForPropertyPath(obj:any, path:string){
     if (!obj || !path || (_.isEmpty(obj)=== true)) {
       return false;
     } else {
      return _.has(obj,path)
     }
    }


    public static parseInt(value : string): number | null {
        if (value === null || value === undefined) {
            return null;
        }
        value = value.toString().trim();
        if (value === '') {
            return null;
        }

        const n = Number(value);
        if (isNaN(n)) {
            return null;
        }

        return n;
    }

    public static isValidNChars(value : string | number, len : number): boolean {
        if (value === null || value === undefined) {
            return false;
        }

        value = value.toString().trim();

        if (value === '' || value.length !== len) {
            return false;
        }

        return true;
    }

    /**
   * @param amount - This is the amount to trim.
   * @param moneyLevelToSkip - This is the key money level to skip. Possible values can be 'H' | 'TH' | 'LAC' | 'CR' | ''
   */
    public static trimAmount(amount : number, moneyLevelToSkip : string) {
        const result = {
            amount: 0,
            longName: '',
            shortName: ''
        };

        if (isNaN(amount) || amount === 0) {
            return result;
        }

        // check if amount is a negative value; if yes, then take the postive part only
        let isNegitive = false;
        if (amount < 0) {
            isNegitive = true;
            amount = amount * -1;
        }

        result.amount = amount;

        const VALUE_OF_CRORE = 10000000;
        const VALUE_OF_LAKH = 100000;
        const VALUE_OF_THOUSAND = 1000;
        const VALUE_OF_HUNDRED = 100;

        if (amount >= VALUE_OF_CRORE) {
            if (moneyLevelToSkip === 'CR') {
                result.amount = amount;
                result.longName = '';
                result.shortName = '';
            } else {
                result.amount = amount / VALUE_OF_CRORE;
                result.longName = 'crore';
                result.shortName = 'cr';
            }
        } else if (amount >= VALUE_OF_LAKH) {
            if (moneyLevelToSkip === 'LAC' || moneyLevelToSkip === 'CR') {
                result.amount = amount;
                result.longName = '';
                result.shortName = '';
            } else {
                result.amount = amount / VALUE_OF_LAKH;
                result.longName = 'lakh';
                result.shortName = 'lac';
            }
        } else if (amount >= VALUE_OF_THOUSAND) {
            if (moneyLevelToSkip === 'TH' || moneyLevelToSkip === 'LAC' || moneyLevelToSkip === 'CR') {
                result.amount = amount;
                result.longName = '';
                result.shortName = '';
            } else {
                result.amount = amount / VALUE_OF_THOUSAND;
                result.longName = 'thousand';
                result.shortName = 'k';
            }
        } else if (amount >= VALUE_OF_HUNDRED) {
            if (
                moneyLevelToSkip === 'H' ||
                moneyLevelToSkip === 'TH' ||
                moneyLevelToSkip === 'LAC' ||
                moneyLevelToSkip === 'CR'
            ) {
                result.amount = amount;
                result.longName = '';
                result.shortName = '';
            } else {
                result.amount = amount / VALUE_OF_HUNDRED;
                result.longName = 'hundred';
                result.shortName = 'h';
            }
        } else {
            result.amount = amount;
            result.longName = '';
            result.shortName = '';
        }

        if (result.amount > 0) {
            result.amount = parseFloat(result.amount.toFixed(2));
        }

        if (isNegitive) {
            result.amount = result.amount * -1;
        }

        return result;
    }

    public static titleCase(text : string) {
        return text.toLowerCase().split(' ').map((item) => {
            return item.charAt(0).toUpperCase() + item.slice(1);
        }).join(' ');
    }

    public static getInvestorAvatar(holdingPattern : string, gender : string) {
        let avatar = 'assets/img/inv-others.svg'; // others

        if (holdingPattern === 'SI') {
            if (gender === 'M') {
                avatar = 'assets/img/comm.svg'; // male
            } else if (gender === 'F') {
                avatar = 'assets/img/comm1.svg'; // female
            } else { // others
            }
        } else if (holdingPattern === 'JO' || holdingPattern === 'AS') {
            avatar = 'assets/img/other.svg'; // joint
        } else { // others
        }
        return avatar;
    }

    public static getSubbrokerAvatar(gender : string) {
        let avatar = 'assets/img/inv-others.svg'; // others
        if (gender === 'M') {
            avatar = 'assets/img/comm.svg'; // male
        } else if (gender === 'F') {
            avatar = 'assets/img/comm1.svg'; // female
        }
        // others
        return avatar;
    }

    public static generateQueryParams(dataToBeEncoded : any): NavigationExtras {
        const navigationExtras: NavigationExtras = {
            queryParams: {
                p: btoa(JSON.stringify(dataToBeEncoded))
            }
        };
        return navigationExtras;
    }

    public static decodeQueryParams(encodedStringData : string): any {
        if (encodedStringData) {
            return JSON.parse(atob(encodedStringData));
        }
    }

    public static readQueryParam(route : ActivatedRoute): any {
        let param = null;
        route.queryParams.subscribe((dataFromObservable) => {
            param = HelperService.decodeQueryParams(dataFromObservable.p);
        }, (error) => { // //HelperService.logError(error);
        });
        return param;
    }

    public static SplitAndTrim(text : string, separator : string): string[]{
        if (text !== null && text !== undefined) {
            text = text.trim().replace(' ', '');
            if (text.length > 0) {
                return text.split(separator);
            }
        }
        return [];
    }

    public static SplitAndTrimToNumbers(text : string, separator : string): number[]{
        const arrayOfString = HelperService.SplitAndTrim(text, separator);

        let n: any;
        const arrayOfNumber: number[] = [];
        for (const item of arrayOfString) {
            if (HelperService.isNullOrEmpty(item) === true) {
                continue;
            }

            n = Number(item);
            if (isNaN(n)) {
                continue;
            }

            arrayOfNumber.push(n);
        }
        return arrayOfNumber;
    }

    public static getNow(): Date {
        return new Date();
    }

    public static getToday(): Date {
        const d = HelperService.getNow();
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    public static addDays(reqDate : Date, days : number) {
        const d = new Date(reqDate.valueOf());
        d.setDate(d.getDate() + days);
        return d;
    }

    public static addMonths(reqDate : Date, months : number) {
        const d = new Date(reqDate.valueOf());
        d.setMonth(d.getMonth() + months);
        return d;
    }

    public static addYears(reqDate : Date, years : number) {
        const d = new Date(reqDate.valueOf());
        d.setFullYear(d.getFullYear() + years);
        return d;
    }

    public static getYesterday() {
        return HelperService.addDays(HelperService.getToday(), -1);
    }

    public static ToIndianCurrencyString(amount : number, addPrefix : boolean) {
        if (addPrefix) {
            return '₹ ' + amount.toLocaleString('en-IN');
        } else {
            return amount.toLocaleString('en-IN');
        }
    }

    public static ToThousandSeparator(value : number, prefix : string, suffix : string): string {
        if (value === null || value === undefined) {
            return '';
        }

        let result = value.toLocaleString('en-IN');
        if (prefix !== null && prefix !== undefined && prefix !== '') {
            result = prefix + result;
        }
        if (suffix !== null && suffix !== undefined && suffix !== '') {
            result = result + suffix;
        }
        return result;
    }

    public static toTitleCase(text : string) {
        if (HelperService.isNullOrEmpty(text)) {
            return '';
        }

        return text.toLowerCase().split(' ').map((word) => {
            return word.replace(word[0], word[0].toUpperCase());
        }).join(' ');
    }
    // public static amount2Words(amount: number): string { let a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ',
    // 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ',
    // 'seventeen ', 'eighteen ', 'nineteen ']; let b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy',
    // 'eighty', 'ninety'];

    // let strAmount = amount.toString(); if (strAmount.length > 9) {
    //     return 'overflow';
    // }

    // const n = ('000000000' + strAmount).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/); if (!n) { return '';
    // }

    // let str = ''; str += (n[1] != '0') ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : ''; str += (n[2]
    // != '0') ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : ''; str += (n[3] != '0') ? (a[Number(n[3])]
    // || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : ''; str += (n[4] != '0') ? (a[Number(n[4])] || b[n[4][0]] + ' ' +
    // a[n[4][1]]) + 'hundred ' : ''; str += (n[5] != '0') ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] +
    // ' ' + a[n[5][1]]) + 'only ' : ''; return str; }

    public static renderTabs(elmId : string) {
        const liCtrlString = `#${elmId}.dyn-tabs .tabs--list li`;
        // const liCount = $('.tabs--list li').length - 1; // li count
        const liCount = $(liCtrlString).length - 1; // li count

        // $('.dyn-tabs .tabs--list li').css({ width: (100 / liCount) + '%' });
        $(liCtrlString).css({
            width: 100 / liCount + '%'
        });

        // const tabs = $('.dyn-tabs'), tabsLists = $('.dyn-tabs ul.tabs--list li');
        const tabs = $(`#${elmId}.dyn-tabs`),
            tabsLists = $(liCtrlString);

        tabs.each(function () {
            const tab = $(this),
                tabItems = tab.find('ul.tabs--list'),
                tabContentWrapper = tab.children('ul.tabs--content');

            // tslint:disable-next-line: space-before-function-paren
            tabItems.on('click', 'a', function (event) {
                event.preventDefault();
                const activedItem = $(this);
                if (! activedItem.hasClass('actived')) {
                    const activedTab = activedItem.data('content'),
                        activedContent = tabContentWrapper.find('li[data-content="' + activedTab + '"]');

                    tabItems.find('a.actived').removeClass('actived');
                    activedItem.addClass('actived');
                    activedContent.addClass('actived').siblings('li').removeClass('actived');
                }
            });
        });

        // tslint:disable-next-line: space-before-function-paren
        tabsLists.click(function (e) {
            if ($(this).hasClass('moving-tab')) {
                return;
            }
            const whatTab = $(this).index();
            // const howMany = $('.tabs--list li').length - 1;
            const howMany = $(liCtrlString).length - 1;
            const howFar = (100 / howMany) * whatTab;

            $('.moving-tab').css({
                left: howFar + '%'
            });
        });
    }

    public static replaceIfExistsAtLast(source : string, replace : string) {
        if (HelperService.isNullOrEmpty(source)) {
            return '';
        }

        source = source.trim();
        const sourceInUppercase = source.toUpperCase();
        const pos = sourceInUppercase.indexOf(replace);
        if (source.length === pos + replace.length) {
            source = source.substr(0, pos);
        }
        return source;
    }

    public isMobile(): boolean {
        const _deviceTypes = [
            'android',
            'ios',
            'iphone',
            'mobile',
            'mobileweb',
            'pwa',
            'phablet',
        ];
        const _currentDeviceType = this.platform.platforms();

        for (const _item of _deviceTypes) {
            if (_currentDeviceType.includes(_item) == true) {
                return true;
            }
        }
        return false;
    }

    public static groupBy(array, f) {
        let groups = {};
        array.forEach(function (o) {
            var group = JSON.stringify(f(o));
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });
        return Object.keys(groups).map(function (group) {
            return groups[group];
        });
    }

    public static getRomanNumber(n) {
        let ord = 'th';

        if (n % 10 == 1 && n % 100 != 11) {
            ord = 'st';
        } else if (n % 10 == 2 && n % 100 != 12) {
            ord = 'nd';
        } else if (n % 10 == 3 && n % 100 != 13) {
            ord = 'rd';
        }
        if (n == null || n == undefined || n == '') {
            return '-';
        }
        return ord;
    }

    public static checkIfArrayHasValuesAndReturnfirstElement(array : any[]) {
        return _.size(array) > 0 ? array[0] : [];
    }



  public static getDateDifferenceToHumanizer(start_date:Date, end_date:Date){
    if(start_date == null || end_date == null){
      return '';
    }
    const d = intervalToDuration({start: start_date,end: end_date});
    var val='';
    val += d.years == 0 ? '' : (d.years == 1 ? d.years + ' Year ' : d.years + ' Years ');
    val += d.months == 0 ? '' : (d.months == 1 ? d.months + ' Month ' : d.months + ' Months ');
    val += d.days == 0 ? '' : (d.days == 1 ? d.days + ' Day ' : d.days + ' Days ');
    return val;
  }

  public static getNumberOfInstallment(_date1, _date2, _freq, _keep_current) {
    let _installment_number = 0;
    if (_keep_current == true) {
      _installment_number = 1;
    }

    let _interval_description = '';
    let _add_suffix = 0;
    switch (_freq) {
      case 'daily':
        _installment_number += differenceInDays(_date2, _date1);
        _add_suffix = parseInt(_installment_number.toString());
        _interval_description = (_add_suffix == 1 || _add_suffix == 0) ? _installment_number + ' day' : _installment_number + ' days';
        break;
      case 'day_in_a_week':
        _installment_number += differenceInWeeks(_date2, _date1);
        _add_suffix = parseInt(_installment_number.toString());
        _interval_description = (_add_suffix == 1 || _add_suffix == 0) ? _installment_number + ' week' : _installment_number + ' weeks';
        break;
      case 'four_times_a_month':
        _installment_number += differenceInDays(_date2, _date1) / 7.60;
        _add_suffix = parseInt(_installment_number.toString());
        _interval_description = (_add_suffix == 1 || _add_suffix == 0) ? _installment_number + ' quad month' : _installment_number + ' quad months';
        break;
      case 'day_in_a_fortnight':
        _installment_number = differenceInDays(_date2, _date1) / 14;
        _add_suffix = parseInt(_installment_number.toString());
        _interval_description = (_add_suffix == 1 || _add_suffix == 0) ? _installment_number + ' fortnight' : _installment_number + ' fortnights';
        break;
      case 'twice_a_month':
        _installment_number = differenceInDays(_date2, _date1) / 15.20;
        _add_suffix = parseInt(_installment_number.toString());
        _interval_description = (_add_suffix == 1 || _add_suffix == 0) ? _installment_number + ' twice a month' : _installment_number + ' twice a months';
        break;
      case 'monthly':
        _installment_number = differenceInMonths(_date2, _date1);
        _add_suffix = parseInt(_installment_number.toString());
        _interval_description = (_add_suffix == 1 || _add_suffix == 0) ? _installment_number + ' month' : _installment_number + ' months';
        break;
      case 'quarterly':
        _installment_number = differenceInQuarters(_date2, _date1);
        _add_suffix = parseInt(_installment_number.toString());
        _interval_description = (_add_suffix == 1 || _add_suffix == 0) ? _installment_number + ' quarter' : _installment_number + ' quarters';
        break;
      case 'half_yearly':
        _installment_number = differenceInMonths(_date2, _date1) / 6;
        _add_suffix = parseInt(_installment_number.toString());
        _interval_description = (_add_suffix == 1 || _add_suffix == 0) ? _installment_number + 'half year' : _installment_number + 'half years';
        break;
      case 'yearly':
        _installment_number = differenceInYears(_date2, _date1);
        _add_suffix = parseInt(_installment_number.toString());
        _interval_description = (_add_suffix == 1 || _add_suffix == 0) ? _installment_number + ' year' : _installment_number + ' years';
        break;
      case 'sporadic':
        _installment_number = null;
        _interval_description = null;
        break;
      default:
        _installment_number = null;
        _interval_description = null;
        break;
    }
    return { total_installment: _installment_number, total_interval: _interval_description };
  }

    public static calcDateRange(dateRangeKey) {
        var dateRange = { fromDate: null, toDate: null, displayText: '' };
        dateRangeKey = dateRangeKey.toUpperCase();

        switch (dateRangeKey) {
            case 'TODAY':
                // on 15 april 23, it will return [15-APR-2023 & 15-APR-2023]
                // format(new Date(), "yyyy-MM-dd'T'HH:mm:ss'Z'");
                // format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
                dateRange.fromDate = format(new Date(), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Today';
                break;
            case '1_Day':
                dateRange.fromDate = format(subDays(new Date(), 1), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = '1 Day';
                break;
            case 'YESTERDAY':
                // on 15 april 23, it will return [14-APR-2023 & 14-APR-2023]
                dateRange.fromDate = format(subDays(new Date(), 1), "yyyy-MM-dd");
                dateRange.toDate = format(subDays(new Date(), 1), "yyyy-MM-dd");
                dateRange.displayText = 'Yesterday';
                break;
            case 'TOMORROW':
                // on 15 april 23, it will return [16-APR-2023 & 16-APR-2023]
                dateRange.fromDate = format(addDays(new Date(), 1), "yyyy-MM-dd");
                dateRange.toDate = format(addDays(new Date(), 1), "yyyy-MM-dd");
                dateRange.displayText = 'Tomorrow';
                break;
            case 'LAST_7_DAYS':
                // on 15 april 23, it will return [09-APR-2023 & 15-APR-2023]
                dateRange.fromDate = format(subDays(new Date(), 6), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Last 7 Days';
                break;
            case 'NEXT_7_DAYS':
                // on 15 april 23, it will return [15-APR-2023 & 21-APR-2023]
                dateRange.fromDate = format(new Date(), "yyyy-MM-dd");
                dateRange.toDate = format(addWeeks(new Date(), 1), "yyyy-MM-dd");//helperService.addDays(helperService.getToday(), 6);
                dateRange.displayText = 'Next 7 Days';
                break;
            case 'LAST_30_DAYS':
                // on 15 april 23, it will return [16-MAR-2023 & 15-APR-2023]
                dateRange.fromDate = format(subDays(new Date(), 29), "yyyy-MM-dd");;
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Last 30 Days';
                break;
            case 'NEXT_30_DAYS':
                // on 15 april 23, it will return [15-APR-2023 & 13-AUG-2023]
                dateRange.fromDate = format(new Date(), "yyyy-MM-dd");
                dateRange.toDate = format(addDays(new Date(), 30), "yyyy-MM-dd");
                dateRange.displayText = 'Next 30 Days';
                break;
            case 'THIS_MONTH':
                // on 15 april 23, it will return [01-APR-2023 & 31-APR-2023]
                dateRange.fromDate = format(new Date(), "yyyy-MM-01");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'This Month';
                break;
            case 'LAST_MONTH':
                // on 15 april 23, it will return [01-MAR-2023 & 30-MAR-2023]
                dateRange.fromDate = format(subMonths(new Date(), 1), "yyyy-MM-01");
                dateRange.toDate = format(lastDayOfMonth(subMonths(new Date(), 1)), "yyyy-MM-dd");
                dateRange.displayText = 'Last Month';
                break;
            case 'NEXT_MONTH':
                // on 15 april 23, it will return [01-MAY-2023 & 31-MAY-2023]
                dateRange.fromDate = format(addMonths(new Date(), 1), "yyyy-MM-01");
                dateRange.toDate = format(lastDayOfMonth(addMonths(new Date(), 1)), "yyyy-MM-dd");
                dateRange.displayText = 'Next Month';
                break;
            case 'FYTD':
                // on 15 april 23, it will return [01-APR-2023 & 15-APR-2023]
                // first calculate apr from the current year..
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.fromDate = format(new Date(), "yyyy-04-01");
                // then update them according to the current month..
                if (Number(format(new Date(), 'L', { locale: enIN })) < 4) {
                    dateRange.fromDate = format(subYears(new Date(dateRange.fromDate), 1), "yyyy-MM-dd");
                }
                dateRange.displayText = 'Financial Year Till Date (FYTD)';
                break;
            case 'CYTD':
                // on 15 april 23, it will return [01-JAN-2023 & 15-APR-2023]
                dateRange.fromDate = format(new Date(), "yyyy-01-01");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Calendar Year Till Date (CYTD)';
                break;
            case 'THIS_FY':
                // on 15 april 23, it will return [01-APR-2023 & 31-MAR-2024]
                // first calculate apr & mar from the current year..
                dateRange.toDate = format(new Date(), "yyyy-03-31");
                dateRange.fromDate = format(new Date(), "yyyy-04-01");
                // then update them according to the current month..
                if (Number(format(new Date(), 'L', { locale: enIN })) < 4) {
                    dateRange.fromDate = format(subYears(new Date(dateRange.fromDate), 1), "yyyy-MM-dd");
                }
                else {
                    dateRange.toDate = format(addYears(new Date(dateRange.toDate), 1), "yyyy-MM-dd");
                }
                dateRange.displayText = 'Current FY';
                break;
            case 'LAST_FY':
                // on 15 april 23, it will return [01-APR-2022 & 31-MAR-2023]
                // first calculate apr & mar from the current year..
                var currentDate = new Date();
                currentDate.setFullYear(currentDate.getFullYear() - 1);

                dateRange.toDate = format(new Date(), "yyyy-03-31");
                dateRange.fromDate = format(currentDate, "yyyy-04-01");
                // then update them according to the current month..
                if (Number(format(new Date(), 'L', { locale: enIN })) < 4) {
                    dateRange.fromDate =  format(subYears(new Date(dateRange.toDate), 1), "yyyy-MM-dd");                    
                }
                else {
                    dateRange.toDate = format(new Date(dateRange.toDate), "yyyy-MM-dd");
                }

                dateRange.displayText = 'Previous FY';
                break;
            case 'NEXT_FY':
                // on 15 april 23, it will return [01-APR-2024 & 31-MAR-2025]
                // first calculate apr & mar from the current year..
                dateRange.toDate = format(new Date(), "yyyy-03-31");
                dateRange.fromDate = format(new Date(), "yyyy-04-01");
                // then update them according to the current month..
                if (Number(format(new Date(), 'L', { locale: enIN })) < 4) {
                    dateRange.toDate = format(addYears(new Date(dateRange.toDate), 1), "yyyy-MM-dd");
                }
                else {
                    dateRange.fromDate = format(addYears(new Date(dateRange.fromDate), 1), "yyyy-MM-dd");
                    dateRange.toDate = format(addYears(new Date(dateRange.toDate), 2), "yyyy-MM-dd");
                }
                dateRange.displayText = 'Next FY';
                break;
            case 'MTD':
                // on 15 april 23, it will return [01-APR-2023 & 15-APR-2023]
                dateRange.fromDate = format(new Date(), "yyyy-MM-01");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Month Till Date';
                break;
            case 'QTD':
                // on 15 may 23, it will return [01-APR-2023 & 15-MAY-2023]
                dateRange.fromDate = format(new Date(startOfQuarter(new Date())), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Quarter Till Date';
                break;
            case 'THIS_QUARTER':
                // on 15 april 23, it will return [01-APR-2023 & 30-JUN-2023]
                dateRange.fromDate = format(new Date(startOfQuarter(new Date())), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(endOfQuarter(new Date())), "yyyy-MM-dd");
                dateRange.displayText = 'Current Quarter';
                break;
            case 'LAST_QUARTER':
                // on 15 april 23, it will return [01-JAN-2023 & 31-MAR-2023]
                dateRange.fromDate = format(new Date(startOfQuarter(subMonths(new Date(), 3))), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(endOfQuarter(new Date(dateRange.fromDate))), "yyyy-MM-dd");
                dateRange.displayText = 'Last Quarter';
                break;
            case 'NEXT_QUARTER':
                // on 15 april 23, it will return [01-JUL-2023 & 30-SEP-2023]
                dateRange.fromDate = format(new Date(startOfQuarter(addMonths(new Date(), 3))), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(endOfQuarter(new Date(dateRange.fromDate))), "yyyy-MM-dd");
                dateRange.displayText = 'Next Quarter';
                break;
            case 'PREV_1_MONTH':
                // on 15 april 23, it will return [16-MAR-2023 & 15-APR-2023]
                dateRange.fromDate = format(new Date(addDays(subMonths(new Date(), 1), 1)), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Previous One Month';
                break;
            case 'PREV_3_MONTH':
                // on 15 april 23, it will return [16-JAN-2023 & 15-APR-2023]
                dateRange.fromDate = format(new Date(addDays(subMonths(new Date(), 3), 1)), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Previous Three Months';
                break;
            case 'PREV_6_MONTH':
                // on 15 april 23, it will return [16-OCT-2022 & 15-APR-2023]
                dateRange.fromDate = format(new Date(addDays(subMonths(new Date(), 6), 1)), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Previous Six Months';
                break;
            case 'PREV_1_YEAR':
                // on 15 april 23, it will return [16-APR-2022 & 15-APR-2023]
                dateRange.fromDate = format(new Date(subYears(new Date(), 1)), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Previous One Year';
                break;
            case 'PREV_2_YEAR':
                // on 15 april 23, it will return [16-APR-2021 & 15-APR-2023]
                dateRange.fromDate = format(new Date(addDays(subYears(new Date(), 2), 1)), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Previous Two Years';
                break;
            case 'SINCE_INCEPTION':
                // on 15 april 23, it will return [01-JAN-1900 & 15-APR-2023]
                dateRange.fromDate = format(new Date(1900, 0, 1), "yyyy-MM-dd");
                dateRange.toDate = format(new Date(), "yyyy-MM-dd");
                dateRange.displayText = 'Previous Two Years';
                break;
            case 'CUSTOM':
                dateRange.fromDate = undefined;
                dateRange.toDate = undefined;
                dateRange.displayText = 'Custom';
                break;
        }
        return dateRange;
    }

    public static getDate(date) {
        return format(new Date(date), "yyyy-MM-dd");
    }

    async getLastLoginIsValid(value) {
    const parsedDate = parse(value, `dd/MM/yyyy 'at' h:mm a`, new Date());
    const minutesDiff = differenceInMinutes(new Date(), parsedDate);

    if (minutesDiff > 30) { // 30-minute session expiry
        return false;
    }
    return true;
}
}

